var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.effect
    ? _c(
        "div",
        { staticClass: "effects-body" },
        [
          _c(
            "div",
            { staticClass: "provider-select" },
            [
              _c(_setup.CLazy, [
                _vm.effect.thumbnail
                  ? _c("img", {
                      staticClass: "thumbnail-image",
                      attrs: {
                        src: _vm.effect.thumbnail,
                        alt: _vm.effect.label,
                        lazy: "",
                      },
                    })
                  : _c("img", {
                      staticClass: "thumbnail-image",
                      attrs: {
                        src: require("@/angular-app/images/placeholderCustomily.png"),
                        alt: _vm.effect.label,
                        lazy: "",
                      },
                    }),
              ]),
              _vm._v(" "),
              _vm.effect.presets
                ? [
                    _c("div", { staticClass: "provider-select-input" }, [
                      _c("label", [_vm._v("Service Provider")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _setup.provider,
                              expression: "provider",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _setup.provider = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        _vm._l(_vm.effect.presets, function (option) {
                          return _c(
                            "option",
                            {
                              key: option.id,
                              domProps: {
                                value: {
                                  type:
                                    option?.effectConfig?.type || option?.id,
                                  id: option?.id,
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.tags[0] || option.label) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                : [
                    _c("div", { staticClass: "provider-selected-label" }, [
                      _vm._v(
                        "\n                " + _vm._s(_vm.effect?.label) + " "
                      ),
                      _vm.effect.tags
                        ? _c("span", [
                            _vm._v("(" + _vm._s(_vm.effect.tags[0]) + ")"),
                          ])
                        : _vm._e(),
                    ]),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _setup.provider
            ? _c("div", [
                _c(
                  "form",
                  {
                    ref: "formRef",
                    staticClass: "space-y-4",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _setup.handleSave.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _setup.currentEffectComponent
                      ? _c(_setup.currentEffectComponent, {
                          tag: "component",
                          attrs: { "image-effect": _setup.formData },
                          on: {
                            "update:image-effect": function ($event) {
                              _setup.formData = $event
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            _setup.ApiKeyRequirementFooter,
            _vm._b(
              { attrs: { preset: _setup.selectedPreset } },
              "api-key-requirement-footer",
              _setup.props.effect && _setup.props.effect.isFree !== undefined
                ? { isFree: _setup.props.effect.isFree }
                : {},
              false
            )
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-content-between custom-footer" },
            [
              _c(_setup.CButton, {
                attrs: {
                  text: _vm.effect.presets ? "Back" : "Close",
                  variant: "secondary",
                },
                on: { click: _setup.handleClose },
              }),
              _vm._v(" "),
              _c(_setup.CButton, {
                attrs: { text: "Apply Effect", variant: "primary" },
                on: { click: _setup.submitForm },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }